<template>
  <div class="groupTerms">
    <i class="material-icons" @click="closeGroupTerms">close</i>
    <h3 class="heading">{{$t('createGroupCon')}}</h3>
    <ul>
      <li> {{$t('getDeal', {minOrderId : minOrderId})}}</li>
        <li>{{$t('makePayment')}}</li>
        <li>{{$t('refundMoney')}}</li>
      
    </ul>
    <div class="term_button">
      <button type="button" class="proceed_button" @click="createGroup()">
        {{$t('goAhead')}}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupTerms",
  props: {
    minOrderData :{
      type: String
    }
  },
  data() {
    return {
      close: false,
    };
  },
  methods: {
    closeGroupTerms() {
      this.$emit("closeGroupTerms", false);
    },
    createGroup() {
       try {
        JSBridgePlugin.fireEvents("CREATE_GROUP");
      } catch (err) {
        console.log(err);
      }
      try {
        JSBridgePlugin.shoppingGroupCreate(this.$route.query.itemId);
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>